import { localize } from '../../util/Localizer'
import { getSpecialities } from '../../redux/actions/providersActions'

const defaultSpecialties = [
  { id: 'Drug', label: localize('pages.providers.dropdownData.drug') },
  { id: 'Dental', label: localize('pages.providers.dropdownData.dental') },
  { id: 'HealthCarePractitioner', label: localize('pages.providers.dropdownData.healthcarePractitioner') }
]

export const providerTypeData = async () => {
  try {
    const specialitiesData = await getSpecialities('en-CA')
    const transformedData = Object.values(specialitiesData).map(speciality => ({
      id: speciality.serviceType,
      label: speciality.serviceTypeDisplayName,
      specialties: speciality.specialties.map(specialty => ({
        id: specialty.id,
        text: specialty.description
      }))
    }))
    return transformedData
  } catch (error) {
    console.error('Failed to fetch specialities:', error)
    return defaultSpecialties
  }
}

export const radiusData = [
  { id: 1000, label: '1 km' },
  { id: 5000, label: '5 km' },
  { id: 10000, label: '10 km' },
  { id: 20000, label: '20 km' },
  { id: 50000, label: '50 km' },
  { id: 100000, label: '100 km' }
]



// WEBPACK FOOTER //
// ./src/widgets/Providers/providersDropdownData.js